import { Card, money, when } from './dsfApi';

export const DsfPlayersCard = ({ players, onPick, picked }) => (
    <Card title="Players (this period)" testid="dsf-players-card">
        {!players?.length ? <p className="text-white/50">No fish-table play in this period.</p> : (
            <div className="max-h-[360px] overflow-auto">
                <table className="w-full text-sm text-[#cfd6dc]">
                    <thead><tr className="text-left text-[11px] uppercase tracking-wider text-[#A0AAB2]">
                        <th className="pb-2">Player</th><th className="pb-2 text-right">Shots</th><th className="pb-2 text-right">Bets</th>
                        <th className="pb-2 text-right">Wins</th><th className="pb-2 text-right">House</th><th className="pb-2 text-right">Last played</th>
                    </tr></thead>
                    <tbody>
                        {players.map((p) => (
                            <tr key={p.user_id} onClick={() => onPick(picked === p.user_id ? null : p.user_id)} data-testid={`dsf-player-${p.user_id}`}
                                className={`cursor-pointer border-t border-white/5 hover:bg-white/5 ${picked === p.user_id ? 'bg-[#39FF14]/10' : ''}`}>
                                <td className="py-1.5"><div className="font-semibold text-white">{p.name || '—'}</div><div className="text-xs text-white/40">{p.email}</div></td>
                                <td className="text-right">{p.shots}</td><td className="text-right tabular-nums">{money(p.bets)}</td>
                                <td className="text-right tabular-nums">{money(p.won)}</td>
                                <td className={`text-right font-bold tabular-nums ${p.profit < 0 ? 'text-red-400' : 'text-[#39FF14]'}`}>{money(p.profit)}</td>
                                <td className="text-right text-xs text-white/50">{when(p.last_played)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <p className="mt-2 text-xs text-white/40">Tap a player to filter the records below. House = bets minus wins (red = player is up).</p>
            </div>
        )}
    </Card>
);
